// extracted by mini-css-extract-plugin
module.exports = {"selectBox__label":"select_selectBox__label__0Rhfa"};